/**
 * 当前有2个测试地址：
 * 1. https://test.eb.qq.com/test.eb.qq.com/index.html
 * 2. https://test-eshop.qq.com/index.html
 *
 * 说明：
 * test.eb.qq.com 域名是直接指向前端WEB腾讯云COS桶的地址
 * test-eshop.qq.com 域名是指向前端NODE转发服务，由NODE转发到前端WEB腾讯云COS桶的地址
 */

const entraceHref = window.location.href.split('#')[0]; // 页面入口地址
let QQRedirectUri = encodeURIComponent('https://test.eb.qq.com/test.eb.qq.com/index.html#/transfer');  // QQ回调中转页
let mobileConfirmBindQqPage = 'https://test.eb.qq.com/test.eb.qq.com/index.html#/mobile/confirmBind/qq'; // 绑定QQ媒体回调地址，这个地址不能随便改，需要在QQ互联平台添加回调地址白名单
if (location.host.includes('test-eshop.qq.com')) {
  QQRedirectUri = encodeURIComponent('https://test-eshop.qq.com/index.html#/transfer');
  mobileConfirmBindQqPage = 'https://test-eshop.qq.com/index.html#/mobile/confirmBind/qq';
}
const authRedirectUrl = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101856298&redirect_uri=${QQRedirectUri}`;

export default {
  accessApiBaseUrl: 'https://access-test.pcgec.qq.com',
  apiBaseUrl: 'https://halospider.sparta.html5.qq.com/post/f1bf5fda4ff057588ad61262633454f7',
  newApiBaseUrl: 'https://router-test.pcgec.qq.com',
  loginUrl: `${entraceHref}#/login`,
  entracePage: `${entraceHref}`,
  userCenterPage: `${entraceHref}#/userCenter`,
  invitePage: `${entraceHref}#/invite`,
  mobileBindMediaPage: `${entraceHref}#/mobile/mediaBind`,
  mobileConfirmBindPage: `${entraceHref}#/mobile/confirmBind`,
  mobileConfirmBindQqPage,
  authWXRedirectUrl: `${entraceHref}#/transfer`,
  authRedirectUrl, // QQ鉴权回调地址，这个地址不能随便改，需要在QQ互联平台添加回调地址白名单
  xeppRegister: 'https://seller.txshop.qq.com/dist/boss.html#/login?from_app=eshop&reg_phone=',
  saasApply: 'https://halodev.sparta.html5.qq.com/e-commerce-apply',
};
